export const BUCKET_LIST_QUERY_KEY = ["buckets"];
export const BUCKET_FACETS_QUERY_KEY = ["bucketfacets"];